module.exports = __webpack_public_path__ + "static/warren-buffett-f7e12d28d0e49be64dd2212c9419770c.jpg";